const fullUrl = window.location.href
export const url = new URL(fullUrl)
export const baseUrl = `${url.protocol}//${url.host}/`
const urlSplit = fullUrl.split('://')
export const firstPartUrl = urlSplit[0]